(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wme-main-product"] && !Shopify.designMode) return;
  try {
    
  class WmeProduct extends HTMLElement {
    connectedCallback() {
      const data = this.querySelector('[data-wme-variants]');
      this.variants = data ? JSON.parse(data.textContent) : [];

      this.mainImage = this.querySelector('[data-wme-main-image]');
      this.priceEl = this.querySelector('[data-wme-price]');
      this.perEl = this.querySelector('[data-wme-per]');
      this.idInput = this.querySelector('[data-wme-id]');
      this.submit = this.querySelector('[data-wme-submit]');
      this.stock = this.querySelector('[data-wme-stock]');
      this.qty = this.querySelector('[data-wme-qty]');

      this.querySelectorAll('[data-wme-variant]').forEach((input) => {
        input.addEventListener('change', () => this.selectVariant(input.value));
      });

      this.querySelectorAll('[data-wme-thumb]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          this.setImage(thumb.dataset.image, thumb.dataset.alt);
        });
      });

      this.querySelectorAll('[data-wme-qty-step]').forEach((button) => {
        button.addEventListener('click', () => {
          if (!this.qty) return;
          const step = parseInt(button.dataset.wmeQtyStep, 10);
          const next = Math.max(1, (parseInt(this.qty.value, 10) || 1) + step);
          this.qty.value = next;
          this.qty.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    }

    selectVariant(id) {
      const variant = this.variants.find((item) => String(item.id) === String(id));
      if (!variant) return;

      this.querySelectorAll('.wme-var').forEach((label) => {
        const input = label.querySelector('[data-wme-variant]');
        label.classList.toggle('is-on', !!input && input.checked);
      });

      if (this.priceEl) this.priceEl.textContent = variant.price;
      if (this.perEl) this.perEl.textContent = variant.per || '';
      if (this.idInput) this.idInput.value = variant.id;

      if (this.submit) {
        this.submit.disabled = !variant.available;
        const label = this.submit.querySelector('span');
        if (label) {
          label.textContent = variant.available
            ? this.dataset.addLabel || label.textContent
            : this.dataset.soldOutLabel || label.textContent;
        }
      }

      if (this.stock) this.stock.toggleAttribute('hidden', !variant.available);

      this.setImage(variant.image, variant.alt);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    setImage(src, alt) {
      if (!src || !this.mainImage) return;
      this.mainImage.src = src;
      this.mainImage.removeAttribute('srcset');
      if (alt) this.mainImage.alt = alt;

      this.querySelectorAll('[data-wme-thumb]').forEach((thumb) => {
        thumb.classList.toggle('is-on', thumb.dataset.image === src);
      });
    }
  }

  if (!customElements.get('wme-product')) {
    customElements.define('wme-product', WmeProduct);
  }

  } catch(e) { console.error(e); }
})();
})();
